export enum VolunteeringTypeEnum {
    ALUMNI = 'Alumni',
    MEMBER = 'Member'
}